import React from 'react';
import { useSetResolved } from '@wearejh/m2-pwa-engine/lib/router';

import { fireGTMEvent } from 'src/features/analytics/hooks/useGtm';
import { ProductRootInner } from 'src/pages/Product/ProductRoot';

type SimpleRootProps = {
    id: number;
    pathname: string;
};

export const SimpleRoot = React.memo(function SimpleRoot(props: SimpleRootProps) {
    useSetResolved();

    React.useEffect(() => {
        fireGTMEvent({ event: 'pageview', pageType: 'Product Page' });
    }, []);

    return <ProductRootInner pathname={props.pathname} id={props.id} />;
});

export default SimpleRoot;
